import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const useAnimation = (ref: React.RefObject<HTMLDivElement>, display: boolean) => {
  const timeline = useRef(gsap.timeline({
    defaults: { ease: "none" },
    paused: true
  }));

  useEffect(() => {
    timeline.current
      .to(ref.current, { duration: 0, display: "flex" }, "0.1")
      .to(ref.current, { duration: 0.25, opacity: 1 });

    return () => { timeline.current.clear() }
  }, []);

  useEffect(() => {
    display ?
      gsap.to(timeline.current, { time: timeline.current.duration(), ease: "power2.out" }) :
      gsap.to(timeline.current, { time: 0, ease: "power2.out", overwrite: true });
  }, [display]);
}

export default useAnimation;